import { __assign } from "tslib";
import { createFakeGetResponder, createFakePostResponder } from '..';
import { createHttpTestKit } from '../http/test-kit';
// import { createFakePostResponder, MockResponse } from '../test-utils';
import { createTenantsApi } from './index';
export var createTenantsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createTenantsApi('', fakeHttp);
    var testKit = {
        whenEnable: function () { return createFakePostResponder(fakeHttp, "/phone/enable")({}); },
        whenDisable: function () { return createFakePostResponder(fakeHttp, "/phone/disable")({}); },
        whenGet: function () { return createFakeGetResponder(fakeHttp, '/tenants'); },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map